import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { SITES_BUILDER_AUTH_SESSION } from "../../auth-session";

export const authGuard: CanActivateFn = (_, state) => {
  const authSession = inject(SITES_BUILDER_AUTH_SESSION);

  if (authSession.isAuthenticated()) return true;

  return authSession.redirectUnauthenticated(state.url);
};
